import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
const STYLES = {
    malicious: 'bg-verdict-malicious/10 text-verdict-malicious ring-verdict-malicious/30',
    suspicious: 'bg-verdict-suspicious/10 text-verdict-suspicious ring-verdict-suspicious/30',
    clean: 'bg-verdict-clean/10 text-verdict-clean ring-verdict-clean/30',
    unknown: 'bg-verdict-unknown/10 text-verdict-unknown ring-verdict-unknown/30',
    // Distinct from clean: we did not gather enough evidence to make a confident call.
    insufficient: 'bg-verdict-unknown/10 text-verdict-unknown ring-verdict-unknown/30',
};
const LABELS = {
    malicious: 'Malicious',
    suspicious: 'Suspicious',
    clean: 'Clean',
    unknown: 'Unknown',
    insufficient: 'Insufficient evidence',
};
/**
 * The semantic verdict pill. Doubles as the embeddable "build-status" badge (section K)
 * and the anchor of the report header (section L). Accessible: conveys state via text +
 * an aria-label, not color alone.
 */
export const VerdictBadge = React.forwardRef(({ verdict, score, size = 'md', className, ...rest }, ref) => {
    const sizeClass = size === 'lg'
        ? 'text-base px-3 py-1.5 gap-2'
        : size === 'sm'
            ? 'text-xs px-2 py-0.5 gap-1'
            : 'text-sm px-2.5 py-1 gap-1.5';
    return (_jsxs("span", { ref: ref, role: "status", "aria-label": `Verdict: ${LABELS[verdict]}${score != null ? `, score ${score} of 100` : ''}`, className: cn('inline-flex items-center rounded-full font-semibold ring-1 ring-inset', STYLES[verdict], sizeClass, className), ...rest, children: [_jsx("span", { "aria-hidden": true, className: "inline-block h-1.5 w-1.5 rounded-full bg-current" }), LABELS[verdict], score != null && _jsx("span", { className: "tabular-nums opacity-80", children: score })] }));
});
VerdictBadge.displayName = 'VerdictBadge';
//# sourceMappingURL=verdict-badge.js.map